module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution-three.da52c4f1.png";